<template>
  <div class="mb-5">
    <v-tabs v-model="selectedTab"
            class="rounded-lg white--text"
            background-color="secondary"
            active-class="primary"
            color="#FF8700">
      <v-tab @click="changeRoute(tab)" v-for="tab in tabs" class="white--text mr-2">{{tab.title}}</v-tab>
    </v-tabs>
  </div>
</template>

<script>
export default {
  name: "WarehouseHandlingTabs",
  data() {
    return {
    };
  },
  computed: {
    selectedTab(){
      if(this.$route.name == 'InventoryClerk') {
        return 0
      }
      if(this.$route.name == 'WarehouseHandlingForm') {
        return 1
      }
      if(this.$route.name == 'WarehouseHandlingList') {
        return 2
      }
    },
    tabs() {
      return [
        {title: 'تعریف انبار گردان', key: '/panel/inventoryClerk'},
        {title: 'ثبت انبار گردانی', key: '/panel/warehouseHandling/form'},
        {title: 'لیست انبار گردانی  ها', key: '/report/lists/warehouseHandling'},
      ]
    },
  },
  methods: {
    changeRoute(tab){
      this.$router.push(tab.key)
    }
  }

};
</script>

<style scoped lang="scss">
</style>

